import { useState } from "react";
import Cleave from "cleave.js/react";
//-----------------------------------------------------
import AutoComplete from "src/components/common/AutoComplete";
import { User } from "src/components/main/authStore";
import { Link, useRouteLoaderData, Form } from "react-router-dom";
//-----------------------------------------------------
export const myAccessOptions = {
    personel: ["edit", "view", "no"],
    office: ["yes", "no"],
    allOffice: ["edit", "view", "no"],
}
const accesses = [
    {title: "Personel", key: "personel"}, 
    {title: "Office", key: "office"}, 
    {title: "Office Status", key: "allOffice"}, 
];
//-----------------------------------------------------
export default function UserForm({
    keyword
}: {
    keyword: "Add" | "Edit"
}){
    const [user, setUser] = useState<Partial<User>>(useRouteLoaderData("user") || {
        email: "", 
        firstName: "",
        middleName: "",
        lastName: "", 
        phoneNumber: "", 
        workPhone: "", 
        extension: "", 
        role: "", 
        ssn: "", 
        birthDay: "", 
        driverLicense: "", 
        hireDate: "", 
        quitDate: "", 
        background: "", 
        personel: "", 
        office: "",
        allOffice: "",
        street: "", 
        zipCode: "", 
        residence: "", 
        residenceState: "CA", 
        address: ""
    } as User);
    //-----------------------------------------------------
    return(
        <Form method = "post" className = "my-3">
            <div className = "d-flex">
                <div className = "flex-grow-1 px-3">
                    <div className = "d-flex my-2">
                        <input type = "hidden" name = "keyword" value = {keyword}/>
                        <input type = "hidden" name = "curUserId" value = {user.id}/>
                        <input type = "hidden" name = "curOffice" defaultValue = {user.office || ""}/>
                        <label htmlFor = "email" className = "fw-bold me-3 py-2 required-field text-nowrap">Email:</label>
                        <input
                            required
                            type = "email"
                            className = "form-control"
                            id = "email"
                            name = "userEmail"
                            value = {user.email}
                            onChange = {e => setUser({...user, email: e.currentTarget.value.toLowerCase()})}
                        />
                    </div>
                    <div className = "d-flex my-2">
                        <label className = "fw-bold me-3 py-2">Name:</label>
                        <input
                            required placeholder = "First Name"
                            className = "form-control me-3"
                            name = "firstName"
                            value = {user.firstName}
                            onChange = {e => setUser({...user, firstName: e.currentTarget.value})}
                        />
                        <input
                            placeholder = "Middle Name"
                            className = "form-control me-3"
                            name = "middleName"
                            value = {user.middleName}
                            onChange = {e => setUser({...user, middleName: e.currentTarget.value})}
                        />
                        <input
                            required
                            placeholder = "Last Name"
                            className = "form-control"
                            name = "lastName"
                            value = {user.lastName}
                            onChange = {e => setUser({...user, lastName: e.currentTarget.value})}
                        />
                    </div>
                    <div className = "d-flex my-2">
                        <label className = "fw-bold me-3 py-2">Phone:</label>
                        <Cleave
                            required
                            placeholder = "Phone Number"
                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^"
                            className = "form-control me-3"
                            name = "phoneNumber"
                            options = {{
                                blocks:[3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                            value = {user.phoneNumber}
                            onChange = {e => setUser({...user, phoneNumber: e.currentTarget.value})}
                        />
                        <Cleave
                            placeholder = "Work Phone"
                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^"
                            className = "form-control me-3"
                            name = "workPhone"
                            options = {{
                                blocks:[3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                            value = {user.workPhone}
                            onChange = {e => setUser({...user, workPhone: e.currentTarget.value})}
                        />
                        <input
                            placeholder = "Office Extension"
                            type = "number"
                            step = "any"
                            className = "form-control"
                            name = "extension"
                            value = {user.extension}
                            onChange = {e => setUser({...user, extension: e.currentTarget.value})}
                        />
                    </div>
                     <div className = "d-flex my-2 align-items-center">
                        <label htmlFor = "address" className = "fw-bold me-3 py-2">Role:</label>
                        <input
                            placeholder = "Role"
                            type = "text"
                            className = "form-control"
                            name = "role"
                            value = {user.role}
                            onChange = {e => setUser({...user, role: e.currentTarget.value})}
                        />
                    </div>
                    <div className = "d-flex my-2 align-items-center">
                        <label htmlFor = "address" className = "fw-bold me-3 py-2">Address:</label>
                        <AutoComplete
                            className = "m-2"
                            id = "address"
                            location = {user.address ?? ""}
                            coords = {user.coords} 
                            locationName = "address" 
                            coordsName = "coords"
                        />
                    </div>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <label htmlFor = "ssn" className = "fw-bold me-3 py-2">SSN:</label>
                        <Cleave
                            pattern = "[0-9]{3}-[0-9]{2}-[0-9]{4}|$^"
                            className = "form-control me-3"
                            style = {{flexGrow: 1}}
                            name = "ssn"
                            id = "ssn"
                            options = {{
                                blocks:[3, 2, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                            value = {user.ssn}
                            onChange = {e => setUser({...user, ssn: e.currentTarget.value})}
                        />
                        <label htmlFor = "birthDay" className = "fw-bold me-3 py-2">Birthday:</label>
                        <input
                            type = "date"
                            min = "1900-01-01"
                            max = "2999-12-31"
                            name = "birthDay"
                            id = "birthDay"
                            className = "form-control"
                            value = {user.birthDay}
                            onChange = {e => setUser({...user, birthDay: e.currentTarget.value})}
                        />
                    </div>
                    <div className = "my-2 d-flex align-items-center text-nowrap">
                        <label htmlFor = "driverLicense" className = "fw-bold py-2">Driver License:</label>
                        <span className = "fw-bold ms-1 py-2 h3 text-info" data-toggle = "tooltip" title = {`only accept Capitalized Letters and Numbers`}>ⓘ</span>
                        <input
                            id = "driverLicense"
                            name = "driverLicense"
                            pattern = "[A-Z0-9]*"
                            className = "ms-3 form-control"
                            value = {user.driverLicense}
                            onChange = {e => setUser({...user, driverLicense: e.currentTarget.value})}
                        />
                    </div>
                    <div className = "my-2 d-flex text-nowrap">
                        <label htmlFor = "hireDate" className = "fw-bold me-3 py-2">Hire Date:</label>
                        <input
                            type = "date"
                            min = "1900-01-01"
                            max = "2999-12-31"
                            required
                            name = "hireDate"
                            id = "hireDate"
                            className = "form-control"
                            value = {user.hireDate}
                            onChange = {e => setUser({...user, hireDate: e.currentTarget.value})}
                        />
                    </div>
                    <div className = "my-2 d-flex text-nowrap">
                        <label htmlFor = "quitDate" className = "fw-bold me-3 py-2">Leave Date:</label>
                        <input
                            type = "date"
                            min = "1900-01-01"
                            max = "2999-12-31"
                            name = "quitDate"
                            id = "quitDate"
                            className = "form-control"
                            value = {user.quitDate ?? ""}
                            onChange = {e => setUser({...user, quitDate: e.currentTarget.value})}
                        />
                    </div>
                    <div className = "my-2 d-flex align-items-center">
                        <label htmlFor = "background" className = "fw-bold me-3">Background:</label>
                        <textarea
                            className = "form-control"
                            id = "background"
                            name = "background"
                            style = {{width: "100%", height: "100%"}}
                            value = {user.background}
                            onChange = {e => setUser({...user, background: e.currentTarget.value})}
                        />
                    </div>
                </div>
                <div className = "flex-grow-1 px-3">
                    <div className = "my-2 text-center fw-bold" style = {{fontSize: "150%"}}>Access Control</div>
                    <div className = "rounded border p-4 d-flex">
                        <div className = "m-1 flex-grow-1">
                            {accesses.map((item, itemIndex) => 
                            <div key = {itemIndex} className = "my-2 d-flex">
                                <label htmlFor = {item.key} className = "fw-bold me-3 py-2 required-field text-nowrap">{item.title}:</label>
                                <select
                                    required
                                    className = "form-control flex-grow-1"
                                    id = {item.key}
                                    name = {item.key}
                                    value = {user[item.key as keyof User] as string}
                                    onChange = {e => setUser({...user, [item.key]: e.currentTarget.value})}
                                >
                                    <option value = "">Select</option>
                                    {myAccessOptions[item.key as keyof typeof myAccessOptions].map((o, oi) => <option key = {oi}>{o}</option>)}
                                </select>
                            </div>)}
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-3">
                <Link children = "Close" className = "btn btn-outline-secondary me-3" to = ".."/>
                <button children = {keyword} className = "btn btn-primary float-end" type = "submit"/>
            </div>
        </Form>
    )
}